import { render, staticRenderFns } from "./balancelog.vue?vue&type=template&id=1afc87e3&"
import script from "./balancelog.vue?vue&type=script&lang=js&"
export * from "./balancelog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports